module.exports = __webpack_public_path__ + "media/src/img/rutube-icon-blue-88bc93599ae964470b2a4e5e8c30914d.svg";